import styled from '@emotion/styled';
import React, { useContext } from 'react';
import { CartContext } from '../../Context/CartContext';
import { ContentfulContext } from '../../Context/Contentful';
import CartHeader from './CartHeader';
import CartItems from './CartItems';
import CartSummary from './CartSummary';

const StyledCartContainer = styled.div`
	.order__summary {
		margin-top: auto;
	}
	.cart__wrapper {
		min-height: calc(100vh - 120px);
	}
	.cart__header {
		margin-bottom: 0px !important;
	}
`;

function CartDetails({
	setStep,
	isLoggedIn,
	allowExistingCustomer,
	showThirdParty,
}) {
	const { cartData, removeFromCart, handleToggleCart, velocityNumberError } =
		useContext(CartContext);

	const { freeItem } = useContext(ContentfulContext);

	const handleCartCheckout = () => {
		if (isLoggedIn && allowExistingCustomer) {
			setStep(5);
		} else {
			setStep(2);
		}
	};

	return (
		<StyledCartContainer>
			<CartHeader title='Shopping Cart' />
			<div className='d-flex flex-column cart__wrapper mt-40'>
				{cartData.length > 0 ? (
					<>
						{cartData.map((item, index) => {
							let { itemCode, product } = item;
							return (
								<CartItems
									key={index}
									itemCode={itemCode}
									cartItem={product}
									removeFromCart={removeFromCart}
								/>
							);
						})}

						{freeItem && (
							<CartItems
								itemCode={freeItem?.itemCode}
								cartItem={freeItem}
								removeFromCart={removeFromCart}
								freeItem={true}
							/>
						)}

						{!isLoggedIn && allowExistingCustomer && (
							<>
								<div className='subtitle roboto lower mb-8 mt-20'>
									Already have an online account?
								</div>
								<p className='mb-16 text-dark-medium'>
									For a faster checkout{' '}
									<span
										className='d-inline-block cursor-pointer dmlp_cart_login'
										onClick={() => setStep(1)}
									>
										<u>click here</u>
									</span>{' '}
									to log in to your account and preload all your information in
									one easy step.
								</p>
							</>
						)}

						<CartSummary cartData={cartData} showThirdParty={showThirdParty} />
						<div className='btn__wrapper'>
							<button
								type='submit'
								className='btn btn-primary w-100 mb-16'
								onClick={() => handleCartCheckout()}
								disabled={velocityNumberError}
							>
								Proceed to Checkout
							</button>
							<div className='text-medium text_small text-center'>
								All prices are inclusive of GST.
							</div>
						</div>
					</>
				) : (
					<div className='dmlp__cart__empty'>
						<h4 className='mt-0 mb-20'>Your shopping cart is empty.</h4>
						<div>
							<button
								type='button'
								className='btn btn-primary-outline btn-outline-primary dmlp__btn'
								onClick={handleToggleCart}
							>
								Continue Shopping
							</button>
						</div>
					</div>
				)}
			</div>
		</StyledCartContainer>
	);
}

export default CartDetails;
